import { render, staticRenderFns } from "./diagnosisLogin.vue?vue&type=template&id=ed92aff6&"
import script from "./diagnosisLogin.vue?vue&type=script&lang=js&"
export * from "./diagnosisLogin.vue?vue&type=script&lang=js&"
import style0 from "./diagnosisLogin.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports